import {patchState, signalStore, withMethods, withProps, withState} from "@ngrx/signals";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {inject} from "@angular/core";
import {FarmStore} from "src/app/domain/assets/farm/farm.store";
import {isValidNfcGpsFixSample} from "src/app/presentation/main-view/map-container/map-utils";
import NfcLocationSampleMetadata = Samples.NfcLocationSampleMetadata;

interface LocationState {
  assetId: string | undefined,
  locationSamples: Samples.AssetSample<Samples.NfcGpsFix>[]
}
interface LocationMetadataState {
  assetId: string | undefined,
  metadata: NfcLocationSampleMetadata[]
}

const initialState: LocationState = {
  assetId: undefined,
  locationSamples: []
}

const metadataInitialState: LocationMetadataState = {
  assetId: undefined,
  metadata: []
}

export const NfcLocationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withProps(() => ({
    farmStore: inject(FarmStore)
  })),
  withMethods(store => ({
    setAssetId(assetId?: string) {
      patchState(store, { assetId });
    },
    setLocationSamples(locationSamples: Samples.AssetSample<Samples.NfcGpsFix>[]) {
      const validSamples = locationSamples.filter(isValidNfcGpsFixSample);
      console.log('[DEBUG nfc-location.store] received', locationSamples.length, 'valid', validSamples.length, locationSamples);
      patchState(store, { locationSamples: validSamples });
    }
  }))
);

export const NfcLocationMetadataStore = signalStore(
  { providedIn: 'root' },
  withState(metadataInitialState),
  withProps(() => ({
    farmStore: inject(FarmStore)
  })),
  withMethods(store => ({
    setAssetId(assetId?: string) {
      patchState(store, { assetId });
    },
    setMetadata(locationSampleMetadata: NfcLocationSampleMetadata[]) {
      console.log('[DEBUG nfc-location-metadata.store] received', locationSampleMetadata.length);
      patchState(store, { metadata: locationSampleMetadata });
    }
  }))
);
